import { fromModel, required, shape, between, when, stopOnFirstFailure } from '@totalsoft/pure-validations';
import { dateIsEqualOrGreaterThanGivenDate, dateIsEqualOrLessThanGivenDate } from 'utils/customValidators';
import { isValidDateFormat } from 'utils/simple-validations';

export const interestDetailValidator = fromModel(model =>
  shape({
    interestTypeId: required,
    startDate:
      [required, dateIsEqualOrLessThanGivenDate(model.endDate) |> when(Boolean(model.endDate)), isValidDateFormat] |> stopOnFirstFailure,
    endDate:
      [required, dateIsEqualOrGreaterThanGivenDate(model.startDate) |> when(Boolean(model.startDate)), isValidDateFormat]
      |> stopOnFirstFailure,
    interestPercent: [required, between(-100.0, 100.0)] |> stopOnFirstFailure
  })
);
